import calendar from './calendar'
import occasions from './occasions/occasions'

export default {
    calendar: calendar,
    occasions: occasions
}